(() => {
  if (window.DLSOptionsLoaded) return;
  window.DLSOptionsLoaded = true;
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const money = n => new Intl.NumberFormat('nl-NL', {style:'currency',currency:'EUR'}).format(n/100);
  const cfg = window.DLSOptionsConfig || {};
  const fees = window.DLSOptionsFees || {};
  const selections = new Map();
  const api = async (path, data) => {
    const response = await nativeFetch(root+path, data instanceof FormData ? {method:'POST',body:data} : data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description==='string'?result.description:'Dit lukte niet. Controleer je keuzes en probeer opnieuw.');
    return result;
  };
  const node = (tag, attrs={}, value) => {
    const el=document.createElement(tag);
    for(const [key,val] of Object.entries(attrs)) if(val!==false && val!=null) el.setAttribute(key,String(val));
    if(value!=null)el.textContent=value;
    return el;
  };
  class Options extends HTMLElement {
    connectedCallback(){
      if(this.ready)return; this.ready=true;
      this.config=cfg[this.dataset.product]; this.form=this.closest('form');
      if(!this.config||!this.form)return;
      this.inputs=[];
      this.append(node('h3',{},'Maak het persoonlijk'));
      this.append(node('p',{class:'dls-options-intro'},'Kies je uitvoering en geef je wensen door. Je keuzes gaan mee met je bestelling.'));
      for(const [idx,field] of this.config.fields.entries()){
        const box=node('div',{class:'dls-option-field'}),id=this.form.getAttribute('id')+'-dls-'+idx;
        box.append(node('label',{for:id},field.label+(field.required?' *':'')));
        let input;
        if(field.type==='choice'){
          input=node('select',{id,name:'properties['+field.label+']',required:field.required});
          input.append(node('option',{value:''},field.required?'Maak een keuze':'Geen voorkeur'));
          field.values.forEach(v=>input.append(node('option',{value:v.label,'data-fee':v.fee},v.label+(v.fee?' (+'+money(v.fee)+')':''))));
          if(field.label==='Cadeauverpakking (gratis)')input.value='Nee';
        }else{
          input=node(field.type==='textarea'?'textarea':'input',{id,name:'properties['+field.label+']',type:field.type==='file'?'file':field.type==='textarea'?null:'text',maxlength:field.max,required:field.required,rows:field.type==='textarea'?3:null});
          if(field.type==='file'){input.accept='.txt,.csv,.xlsx,.xls,.pdf,.doc,.docx,.png,.jpg,.jpeg,.svg';box.append(node('small',{},'Of vul de namen hierboven in. Maximaal 20 MB.'));}
        }
        const saved=selections.get(this.dataset.product)?.[field.label];
        if(saved!==undefined&&field.type!=='file')input.value=saved;
        box.append(input);this.append(box);this.inputs.push({field,input,box});
      }
      this.total=node('p',{class:'dls-options-total','aria-live':'polite'});
      this.error=node('p',{class:'dls-options-error',role:'alert'});
      this.append(this.total,node('small',{},'Eventuele meerprijzen staan in je winkelwagen direct onder het product.'),this.error);
      const remember=()=>{selections.set(this.dataset.product,Object.fromEntries(this.inputs.filter(x=>x.field.type!=='file').map(x=>[x.field.label,x.input.value])));this.update();};
      this.addEventListener('change',remember);
      this.form.addEventListener('input',remember);
      this.update();
    }
    value(label){return this.inputs.find(x=>x.field.label===label)?.input.value;}
    update(){
      const personal=this.value('Personalisatie');
      for(const {field,input,box} of this.inputs){
        const conditional=field.personal||(['Lettertype','Lettertype personalisatie'].includes(field.label)&&personal!==undefined);
        box.hidden=conditional&&personal!=='Ja'; input.disabled=box.hidden;
        input.required=field.required||(field.personal&&personal==='Ja');
        if(field.label==='Inclusief thee'){
          const size=this.value('Formaat');
          for(const opt of input.options) if(opt.value.startsWith('Ja'))opt.disabled=!opt.value.toLowerCase().includes((size||'__').toLowerCase());
          if(input.selectedOptions[0]?.disabled)input.value='';
        }
      }
      const variant=this.form.querySelector('[name="id"]')?.value;
      this.total.textContent='Prijs per stuk met jouw keuzes: '+money((this.config.variants[variant]||0)+this.extras().reduce((s,x)=>s+x.amount,0));
    }
    extras(){return this.inputs.filter(x=>!x.input.disabled&&x.field.type==='choice').map(({field,input})=>({label:field.label+': '+input.value,amount:field.values.find(v=>v.label===input.value)?.fee||0})).filter(x=>x.amount>0);}
    async submit(){
      if(this.busy)return;this.update();this.error.textContent='';
      if(!this.form.reportValidity())return;
      const file=this.inputs.find(x=>x.field.type==='file')?.input;
      if(file?.files[0]?.size>20*1024*1024){this.error.textContent='Het bestand is groter dan 20 MB. Kies een kleiner bestand.';return;}
      if(file&&!file.files.length&&!this.value('Voer hier de gewenste namen in')?.trim()){this.error.textContent='Vul de namen in of voeg een namenbestand toe.';return;}
      const data=new FormData(this.form), extra=this.extras(), group=crypto.randomUUID();
      data.delete('sections');data.delete('sections_url');data.set('properties[_dls_group]',group);data.set('properties[_dls_product]',this.dataset.product);
      data.set('properties[_dls_fees]',JSON.stringify(extra.map(x=>({id:fees[x.amount],label:x.label}))));
      for(const [k,v]of [...data.entries()])if(v instanceof File&&!v.size)data.delete(k);
      const button=this.form.querySelector('[type="submit"]');this.busy=true;if(button)button.disabled=true;
      let added;
      try{
        added=await api('cart/add.js',data);
        if(extra.length)await api('cart/add.js',{items:extra.map(x=>({id:fees[x.amount],quantity:added.quantity,parent_line_key:added.key,properties:{'Keuze':x.label,'_dls_extra':group}}))});
        const cart=await api('cart.js');
        const parent=cart.items.find(x=>x.properties?._dls_group===group);
        if(!parent||extra.some(x=>!cart.items.some(c=>c.parent_relationship?.parent_key===parent.key&&c.variant_id===fees[x.amount]&&c.quantity===parent.quantity)))throw new Error('De extra’s zijn niet volledig toegevoegd. Probeer het opnieuw.');
        window.location.assign(root+'cart');
      }catch(error){
        if(added?.key){try{await api('cart/change.js',{id:added.key,quantity:0});}catch(_){this.error.textContent='Controleer je winkelwagen: het product kon niet automatisch worden verwijderd. ';}}
        this.error.textContent+=error.message;
      }finally{this.busy=false;if(button)button.disabled=false;}
    }
  }
  if(!customElements.get('dls-product-options'))customElements.define('dls-product-options',Options);
  document.addEventListener('submit',event=>{
    const editor=event.target.querySelector?.('dls-product-options');
    if(editor){event.preventDefault();event.stopImmediatePropagation();editor.submit();}
  },true);
  // Capture theme button dispatch as well as regular HTML form submission.
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('button');
    const editor=button?.type==='submit'?button.form?.querySelector('dls-product-options'):button?.getAttribute('on:click')==='/handleAddToCartClick'?document.querySelector('dls-product-options'):null;
    if(editor){event.preventDefault();event.stopImmediatePropagation();editor.submit();}
  },true);
  const verifyCart=async()=>{
    const cart=await api('cart.js');
    for(const parent of cart.items.filter(x=>x.properties?._dls_group)){
      const config=cfg[parent.product_id];if(!config)continue;
      const expected=config.fields.flatMap(f=>{const v=f.values?.find(v=>v.label===parent.properties[f.label]);return v?.fee?[{id:fees[v.fee],label:f.label+': '+v.label}]:[];});
      const children=cart.items.filter(x=>x.parent_relationship?.parent_key===parent.key);
      if(expected.some(e=>!children.some(c=>c.variant_id===e.id&&c.quantity===parent.quantity))||children.length!==expected.length)throw new Error('De extra’s van '+parent.product_title+' komen niet overeen. Verwijder dit product en voeg het opnieuw toe met je gewenste keuzes.');
    }
    return cart;
  };
  document.addEventListener('click',async event=>{
    const checkout=event.target.closest?.('[name="checkout"],a[href="/checkout"]');if(!checkout)return;
    event.preventDefault();event.stopImmediatePropagation();if(checkout.dataset.checking)return;
    checkout.dataset.checking='1';
    try{await verifyCart();window.location.assign(root+'checkout');}catch(e){alert(e.message);}finally{delete checkout.dataset.checking;}
  },true);
  document.addEventListener('click',async event=>{
    const b=event.target.closest?.('[data-dls-change-quantity]');if(!b)return;
    event.preventDefault();event.stopImmediatePropagation();if(b.disabled)return;b.disabled=true;
    try{
      const q=Number(document.getElementById(b.dataset.input).value);
      if(!Number.isInteger(q)||q<1)throw new Error('Kies een geldig aantal van minimaal 1.');
      let cart=await api('cart/change.js',{id:b.dataset.key,quantity:q});
      const updates={};cart.items.filter(x=>x.parent_relationship?.parent_key===b.dataset.key).forEach(x=>updates[x.key]=q);
      if(Object.keys(updates).length)await api('cart/update.js',{updates});
      await verifyCart();window.location.reload();
    }catch(e){alert(e.message);b.disabled=false;}
  },true);
})();
